import React, { createContext, useContext, useState, useCallback } from "react";

type AnnouncementContextType = {
  announce: (message: string, callback?: () => void) => void;
};

const AnnouncementContext = createContext<AnnouncementContextType | null>(null);

export const useAnnouncement = (): AnnouncementContextType => {
  const context = useContext(AnnouncementContext);
  if (!context) {
    throw new Error("useAnnouncement must be used inside AnnouncementProvider");
  }
  return context;
};

export const AnnouncementProvider = ({ children }: { children: React.ReactNode }) => {
  const [message, setMessage] = useState("");

  const announce = useCallback((newMessage: string, callback?: () => void) => {

    setMessage("");
 
    setTimeout(() => {
      requestAnimationFrame(() => {
        if (callback) {
          callback();
        }
        setMessage(newMessage);
      });
    }, 100);
  }, []);

  return (
    <AnnouncementContext.Provider value={ { announce } }>
      { children }

      { /* Global live region */ }
      <div
        aria-live="polite"
        aria-atomic="true"
        style={ {
          position: "absolute",
          width: "1px",
          height: "1px",
          padding: 0,
          margin: "-1px",
          overflow: "hidden",
          clip: "rect(0 0 0 0)",
          clipPath: "inset(50%)",
          whiteSpace: "nowrap",
          border: 0
        } }
      >
        { message }
      </div>
    </AnnouncementContext.Provider>
  );
};
